export default class Numbers {
    /**
     * function createGUID - Create unique id
     * @return {string}
     */
    static createGUID() {
        let time = new Date().getTime();

        function s4() {
            return Math.floor((1 + Math.random() * time) * 0x10000)
                .toString(16)
                .substring(1);
        }

        return s4().substr(0, 10);
    }

}